module.exports = __webpack_public_path__ + "static/Background-scot-1.0ea2a733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-scot-1.jpg
// module id = 474
// module chunks = 153228935106781